import { useEffect } from "react";
import { ThreadEvent } from "@/models/agent/threadEvent";
import { AgentService } from "@/services/agent/agent.service";

export const useAgentStream = (
  threadId?: string,
  onProgressEvent?: (event: ThreadEvent) => void,
) => {
  useEffect(() => {
    if (!threadId || !onProgressEvent) return;

    console.log("[useAgentStream] Connecting to stream for thread:", threadId);
    const cleanup = AgentService.subscribeToStream(threadId, onProgressEvent);

    return () => {
      console.log("[useAgentStream] Closing stream for thread:", threadId);
      cleanup();
    };
  }, [threadId, onProgressEvent]);
};
